import React from 'react'
import { Provider } from 'react-redux'
import { createStore } from 'redux'

import rootReducer from './src/redux/reducers'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { PersistGate } from 'redux-persist/integration/react'

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [
    'bookingsReservations'
  ]
}

// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element }) => {
	const persistedReducer = persistReducer(persistConfig, rootReducer)
  const store = createStore(
  	persistedReducer,
  	process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
  const persistor = persistStore(store)
  return (
  	<Provider store={store}>
	  	<PersistGate loading={null} persistor={persistor}>
	  		{element}
		  </PersistGate>
  	</Provider>
	 )
}
